import { useParams } from "react-router-dom";
import { useCDPRole } from "../cdp-role-context";
import Loader from "../common/loader";
import ChannelDeliveryViewForm from "../components/channel-delivery/delivery-view-form";
import ErrorBoundary from "../components/error-boundary";
import { useFeatureFlagQuery } from "../hasura.graphql";

const ChannelDeliveryById = () => {
  const { id } = useParams();
  const { setCDPRole } = useCDPRole();
  const { data, loading, error } = useFeatureFlagQuery({
    onCompleted: (data) => {
      setCDPRole(data.feature_flag.map((feat) => feat.feature));
    },
  });
  if (loading)
    return (
      <div className="mx-6 mt-4">
        <Loader />
      </div>
    );
  if (error) return null;
  if (!data) return null;

  return (
    <ErrorBoundary>
      <ChannelDeliveryViewForm isModal={false} deliveryId={id!} />
    </ErrorBoundary>
  );
};

export default ChannelDeliveryById;
